import {
  clearEmailDraftIfCreateNew,
  EmailDraftCreateActionSelectModal,
  useEmailCreationFormInitialValues,
  useEmailDraft,
  useEmailGetActiveAccountForCreate,
} from '../../../../Email'
import { useRequestProfileContext } from '../../../RequestProfile.hooks'
import { EMAIL_AUDIENCE_BY_RECIPIENT_TYPE } from '../../RequestProfileTabEmailsAddButton'

import { getToRecipients } from './useRequestProfileTabEmailsAddButton.utils'

export function useRequestProfileTabEmailsAddButton({
  requestData,
  onCloseModal,
  onOpenPopUp,
  onSetModal,
}) {
  const { requestContractors } = useRequestProfileContext()

  const { activeAccountForCreate } = useEmailGetActiveAccountForCreate({
    withServiceAccount: true,
  })

  const emailInitial = useEmailCreationFormInitialValues({
    account: activeAccountForCreate,
  })

  const { draft: emailDraft, setDraft: setEmailDraft } = useEmailDraft()

  function handleSelect({ value: recipientType }) {
    const audience = EMAIL_AUDIENCE_BY_RECIPIENT_TYPE[recipientType]

    const initialValues = {
      ...emailInitial,
      to: getToRecipients({
        recipientType,
        requestContractors,
        requestData,
      }),
    }

    if (emailDraft) {
      onSetModal(
        <EmailDraftCreateActionSelectModal
          draft={emailDraft}
          initialValues={initialValues}
          onCancel={onCloseModal}
          onSubmit={({ action, initialValues }) => {
            clearEmailDraftIfCreateNew(action, setEmailDraft)
            onCloseModal()
            onOpenPopUp({ audience, initialValues })
          }}
        />
      )

      return
    }

    onOpenPopUp({ audience, initialValues })
  }

  return { handleSelect }
}
